import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { ContentProvider } from "@/context/ContentContext";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import PackagesPage from "@/pages/PackagesPage";
import ServicesPage from "@/pages/ServicesPage";
import Impressions from "@/pages/Impressions";
import InquiryPage from "@/pages/InquiryPage";
import ConsultationPage from "@/pages/ConsultationPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Cookies from "@/pages/Cookies";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <LanguageProvider>
      <ContentProvider>
        <div className="App font-body">
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/ueber-uns" element={<About />} />
                <Route path="/packages" element={<PackagesPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/eindruecke" element={<Impressions />} />
                <Route path="/anfrage" element={<InquiryPage />} />
                <Route path="/termin" element={<ConsultationPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/kontakt" element={<ContactPage />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/cookies" element={<Cookies />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </ContentProvider>
    </LanguageProvider>
  );
}

export default App;
